import React from 'react';
import { NonIdealState, Button } from '@blueprintjs/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';

const UserProfileBlocked = ({ onProfilesClick }) => {
  const { t } = useTranslation();

  return (
    <NonIdealState
      icon={<FontAwesomeIcon icon={['far', 'lock']} />}
      title={t('Access Restricted')}
      description={
        <div>
          <p>
            {t(
              'You do not have access to view this profile type. Access to this profile type has been restricted by your administrator.'
            )}
          </p>
        </div>
      }
      action={
        <Button intent="primary" onClick={onProfilesClick}>
          {t('View Profiles')}
        </Button>
      }
    />
  );
};

export default UserProfileBlocked;

